import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "800",
  height: "800",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M14.47 16.53a.75.75 0 0 1 0-1.06l2.72-2.72H5a.75.75 0 0 1 0-1.5h12.188L14.47 8.531a.75.75 0 1 1 1.061-1.061l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.061 0" }, null, -1)
  ]))]))
}
export default { render: render }